var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { applyOpenGraphThumbnailSize, classNames } from '@shapeable/utils';
import { EntityCard, EntityCardDefaultProps } from './entity-card';
import { ComponentPropsProvider } from '../context/component-props-context';
import { PersonCardImage } from './person-card-image';
import { PersonCardMeta } from './person-card-meta';
var cls = classNames('person-card');
export var PersonCardDefaultProps = __assign(__assign({}, EntityCardDefaultProps), {
  showColorStrip: false,
  showDescription: false,
  showTypeHeader: false
});
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    // quick-fix for chevron color, until button is moved to color token system\n    ", ";\n  "], ["\n    // quick-fix for chevron color, until button is moved to color token system\n    ", ";\n  "])), theme.FILL('dark'))
});
// -------- Components -------->
var My = {
  Container: styled(EntityCard)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var PersonCard = function (props) {
  var _a;
  var className = props.className,
    cardProps = __rest(props, ["className"]);
  var entity = applyOpenGraphThumbnailSize('bubbleLarge')(props.entity);
  return React.createElement(ComponentPropsProvider, {
    value: {
      Badge: {
        colors: {
          background: (_a = entity.color) === null || _a === void 0 ? void 0 : _a.value
        }
      }
    }
  }, React.createElement(My.Container, __assign({}, cardProps, {
    className: cls.name(className),
    entity: entity,
    showImage: false,
    head: React.createElement(PersonCardImage, {
      entity: entity
    }),
    meta: React.createElement(PersonCardMeta, {
      entity: entity
    })
  })));
};
PersonCard.defaultProps = PersonCardDefaultProps;
PersonCard.cls = cls;
var templateObject_1, templateObject_2;